import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';
//import { Timeline, TimelineItem }  from 'vertical-timeline-component-for-react';
//import arrowImg from './img/Arrow.png';
import './App.css';
import InfoLanding from './components/InfoLanding';
import LeisureLanding from './components/LeisureLanding';
import RecommendLanding from './components/RecommendLanding';
import Main from './components/Main';
import logoImg from './img/Logo.png';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas, faArrowRight, faArrowDown } from '@fortawesome/free-solid-svg-icons';

library.add(fas, faArrowRight, faArrowDown);

class App extends Component {

  constructor() {
    super();
    this.state = {
      scrolledOnce: false,
      topBarHidden: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', (e) => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;;
      if (scrollTop >= 120) {
        document.querySelector('.header').style.animation = '1s headerGoAway';
        document.querySelector('.header').style.top = '-120px';
        this.setState({
          scrolledOnce: true,
          topBarHidden: true,
        });
      } else if (this.state.scrolledOnce) {
        document.querySelector('.header').style.animation = '1s headerGoBack';
        document.querySelector('.header').style.top = '0px';
        this.setState({
          topBarHidden: false,
        });
      }
    });
  }

  render() {
    return (
      <Router>
        <div className='App'>
          <header className='header'>
              <img className='logo' src={logoImg} />
              <ul className='header-menu'>
                <li><Link to='/'>Статистика</Link></li>
                <li><Link to='/info'>Информация</Link></li>
                <li><Link to='/recommend'>Рекомендации</Link></li>
              </ul>
            </header>
          
          <Switch>
            <Route path="/recommend">
              <RecommendLanding />
            </Route>
            <Route path="/info">
              <InfoLanding />
            </Route>
            <Route path="/leisure">
              <LeisureLanding />
            </Route>
            <Route path="/">
              <Main topBarHidden={this.state.topBarHidden} />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
